import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LaddaButton from "../buttons/laddaButton";
import { useMediaQuery } from "@mui/material";

/**
 * Dialog reutilizable. styled(Dialog) vive fuera del render para evitar
 * re-montajes y parpadeos al escribir en formularios dentro del modal.
 */
const ModalComponent = ({
  open,
  handleClose,
  title,
  children,
  actions,
  width,
  maxWidth
}) => {
  const isSmallScreen = useMediaQuery("(max-width:590px)");

  const paperSx = {
    width: width || "auto",
    minWidth: "290px",
    maxWidth: maxWidth ? maxWidth : "100vw",
    ...(isSmallScreen ? { margin: "10px" } : {})
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      PaperProps={{ sx: paperSx }}
    >
      {title && (
        <DialogTitle id="modal-title">
          <span className="gm-title">{title}</span>
        </DialogTitle>
      )}
      <DialogContent className="modal-component-dialog-content">
        {children}
      </DialogContent>
      <DialogActions>
        {actions ? (
          actions
        ) : (
          <LaddaButton variant="contained" onClick={handleClose}>
            <div className="HContainer align-center">
              <p className="button_text">Cerrar</p>
            </div>
          </LaddaButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ModalComponent;
